var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99947 17H1.99947C1.82908 16.9999 1.66153 16.9563 1.51274 16.8733C1.36394 16.7902 1.23883 16.6706 1.14927 16.5256C1.05971 16.3806 1.00868 16.2152 1.00101 16.045C0.993346 15.8748 1.0293 15.7054 1.10547 15.553L2.99947 11.763V9C2.99947 6.87827 3.84232 4.84344 5.34261 3.34315C6.8429 1.84285 8.87773 1 10.9995 1C13.1212 1 15.156 1.84285 16.6563 3.34315C18.1566 4.84344 18.9995 6.87827 18.9995 9V11.764L20.8935 15.553C20.9696 15.7054 21.0056 15.8748 20.9979 16.045C20.9903 16.2152 20.9392 16.3806 20.8497 16.5256C20.7601 16.6706 20.635 16.7902 20.4862 16.8733C20.3374 16.9563 20.1699 16.9999 19.9995 17H14.9995M6.99947 17H14.9995M6.99947 17C6.99947 18.0609 7.42089 19.0783 8.17104 19.8284C8.92118 20.5786 9.9386 21 10.9995 21C12.0603 21 13.0777 20.5786 13.8279 19.8284C14.578 19.0783 14.9995 18.0609 14.9995 17",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.de8f3b3534fb43b5e06c7db9d9ac18c3.svg";
export { ForwardRef as ReactComponent };